import {
  Button,
  Grid,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import FilterListIcon from "@material-ui/icons/FilterList";
import PopupDuplicate from "app/PatientManagement/CheckInList/Popup/PopupDuplicate";
import CheckInGeneralPopup from "app/PatientManagement/CheckInList/Popup/CheckInGeneralPopup";
import LeadSearchPopup from "app/PatientManagement/PatientList/Popup/LeadSearchPopup";
import TableComponent from "app/common/Component/Table/TableComponent";
import GlobitsConfirmationDialog from "app/common/GlobitsConfirmationDialog";
import IconDelete from "app/common/Icon/IconDelete";
import IconPen from "app/common/Icon/IconPen";
import { getDateTime, isAdmin, isRoleHisReadOnly } from "app/common/LocalFunction";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { pagingDepartment } from "app/services/DepartmentService";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import ListCheckInDependentPerson from "./Popup/ListCheckInDependentPerson";
import HistoryIcon from "@material-ui/icons/History";
import CheckInHistoryElasticPopup from "app/PatientManagement/CheckInList/Popup/CheckInHistoryElasticPopup";

const ListCheckIn = ({ isOpenFillter, setOpenFillter }) => {
  const { t } = useTranslation();
  const {
    handleOpenFormCreateOrEdit,
    searchCheckIn,
    pageCheckIn,
    handleChangeFormSearch,
    handleDeleteCheckIn,
    openCheckin,
    handleCloseCheckinPopup,
    openCheckInDependentPersonPopup,
    handleCloseCheckInDependentPersonPopup,
    initCheckInDependentPerson,
    saveCheckCompanions,
    handleChangeFormSearchDependentPerson,
    customerSourceForCompanionDefault,
    openPopupSearchDependentPersonLead,
    handleClosePopupSearchDependentPersonLead,
    duplicatePatients,
    searchDuplicatePatient,
    handleSelectDependentPersonLeadPatient,
    openPopupCheckDuplicateDependentPerson,
    handleClosePopupCheckDuplicateDependentPerson,
    handleSelectDuplicateDependentPerson,
    handleChangeFormSearchDuplicateOnlyLead,
    openCheckInHistoryElasticPopup,
    searchCheckInHistoryElastic,
    pageCheckInHistoryElastic,
    handleOpenCheckInHistoryElastic,
    handleCloseCheckInHistoryElastic,
    handleChangeFormSearchCheckInHistoryElastic,
  } = useStore().patientManagementStore.listCheckInStore;

  // Dùng chung popup "CheckInGeneralPopup" (giao diện chuẩn) từ CheckInList
  const {
    openCheckin: openCheckinGeneral,
    handleOpenFormCreateOrEdit: handleOpenCheckinGeneral,
    handleCloseCheckinPopup: handleCloseCheckinGeneral,
    // popup chọn lead khi chỉnh sửa / check trùng
    openPopupSearchLead: openPopupSearchLeadGeneral,
    handleClosePopupSearchLead: handleClosePopupSearchLeadGeneral,
    duplicatePatients: duplicatePatientsGeneral,
    searchDuplicatePatient: searchDuplicatePatientGeneral,
    handleSelectLeadPatient: handleSelectLeadPatientGeneral,
    handleChangeFormSearchDuplicate: handleChangeFormSearchDuplicateGeneral,
    // popup search lead (chỉnh sửa checkin - kiểu "personal")
    openSearchLead: openSearchLeadGeneral,
    handleCloseSearchListPopup: handleCloseSearchListPopupGeneral,
    leadPatient: leadPatientGeneral,
    handleSelectLeadSelectLeadPersonal: handleSelectLeadSelectLeadPersonalGeneral,
    handleSearchDuplicateInPersonal: handleSearchDuplicateInPersonalGeneral,
  } = useStore().patientManagementStore.checkInListStore;

  const { handleGetPatientOverviewByIdNotLoading } =
    useStore().patientManagementStore.patientGeneralStore;
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isReadonly = isRoleHisReadOnly();
  const isAdminRole = isAdmin();
  return (
    <>
      <Grid
        container
        spacing={1}
        className="justify-center cards-body checkin-table-wrapper"
        style={{ paddingTop: 0, paddingBottom: 0 }}
      >
        <Grid item xs={12}>
          <div className="cards-header flex gap-2">
            <h4 style={{ fontSize: "16px" }}>Danh sách check in</h4>
            <span
              style={{ cursor: "pointer" }}
              className="flex items-center"
              onClick={() => setOpenFillter(!isOpenFillter)}
            >
              <FilterListIcon color="red" />
            </span>
          </div>
        </Grid>
        {!isOpenFillter && (
          <Grid item xs={12}>
            <style>
              {`
                @keyframes slideDownFade {
                  0% {
                    opacity: 0;
                    transform: translateY(-10px);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
              `}
            </style>
            <div
              style={{
                animation: "slideDownFade 0.3s ease forwards",
                position: "relative",
                zIndex: 12,
              }}
            >
              <Grid container spacing={1} className="cards-body">
                <Grid item xs={12} sm={6} md={4}>
                  <GlobitsMultiDatePicker
                    label="Từ ngày - đến ngày"
                    name="fromDate"
                    range
                    rangeHover
                    fromField="fromDate"
                    toField="toDate"
                  // format={"DD/MM/YYYY"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobitsPagingAutocomplete
                    name={"departmentId"}
                    label={"Cơ sở"}
                    api={pagingDepartment}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className="flex flex-end gap-2"
                >
                  <Button className="btn-primary" type="submit">
                    <Search />
                    Tìm kiếm
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Grid>
        )}
        <Grid item xs={12}>
          <TableComponent
            showOrdinalNumbers
            name="ListTabCheckIn"
            showMoreButton
            titleNodata={t("noData")}
            data={pageCheckIn?.content || []}
            doubleClick={(patient) => {
              handleOpenCheckinGeneral(patient);
            }}
            columns={[
              {
                title: t("action"),
                field: "action",
                align: "center",
                render: (patient) => (
                  <div className="flex-center gap-2">
                    {!isReadonly && (
                      <>
                        <Tooltip title="Chỉnh sửa">
                          <div
                            onClick={() => {
                              handleOpenCheckinGeneral(patient);
                            }}
                          >
                            <IconPen />
                          </div>
                        </Tooltip>
                        {isAdminRole && (
                          <Tooltip title="Hủy check in">
                            <div
                              className="flex"
                              onClick={() => {
                                handleDeleteCheckIn(patient);
                              }}
                            >
                              <IconDelete />
                            </div>
                          </Tooltip>
                        )}
                        <Tooltip title="Xem lịch sử thay đổi">
                          <div
                            className="flex"
                            onClick={() => {
                              handleOpenCheckInHistoryElastic(patient);
                            }}
                          >
                            <HistoryIcon style={{ color: "#006778" }} />
                          </div>
                        </Tooltip>
                      </>
                    )}
                  </div>
                ),
              },

              {
                field: "checkin",
                title: t("Thời gian check in"),
                render: (val) => getDateTime(val?.encounterDatetime),
              },
              {
                field: "checkin",
                title: t("Thời gian check out"),
                render: (val) => getDateTime(val?.visitStopDateTime),
              },
              {
                field: "practitioner.staffName",
                title: t("Người check in"),
              },
              {
                field: "currentVisitDepName",
                title: t("Cơ sở checkin"),
              },
              {
                field: "companion.displayName",
                title: t("Người đi cùng"),
                render: (row) => (
                    <div>
                        <p>{row?.companion?.displayName}</p>
                        <p>{row?.companion?.code}</p>
                    </div>
                ),
            },
              {
                field: "typeOfVisit.name",
                title: t("Loại check in"),
              },
              {
                field: "createDate",
                title: t("Thời gian tạo theo (HT)"),
                render: (val) => getDateTime(val?.createDate),
              },
              {
                field: "modifyDate",
                title: t("Thời gian sửa theo (HT)"),
                render: (val) => getDateTime(val?.modifyDate),
              },
            ]}
            dataPagination={{
              pageIndex: searchCheckIn?.pageIndex,
              pageSize: searchCheckIn?.pageSize,
              totalElements: pageCheckIn?.totalElements,
              totalPages: pageCheckIn?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
          {openCheckinGeneral && (
            <CheckInGeneralPopup
              handleAfterSubmit={() => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          )}

          {/* Popup chọn Lead (được mở từ CheckInGeneralPopup khi check trùng / chỉnh sửa) */}
          {openPopupSearchLeadGeneral && (
            <LeadSearchPopup
              open={openPopupSearchLeadGeneral}
              handleClose={handleClosePopupSearchLeadGeneral}
              leadPatient={duplicatePatientsGeneral}
              searchLead={searchDuplicatePatientGeneral}
              handleSelect={handleSelectLeadPatientGeneral}
              handleChangeFormSearch={handleChangeFormSearchDuplicateGeneral}
            />
          )}

          {/* Popup search Lead (màn danh sách lead khi chỉnh sửa checkin) */}
          {openSearchLeadGeneral && (
            <LeadSearchPopup
              open={openSearchLeadGeneral}
              handleClose={handleCloseSearchListPopupGeneral}
              leadPatient={leadPatientGeneral}
              searchLead={searchDuplicatePatientGeneral}
              handleSelect={handleSelectLeadSelectLeadPersonalGeneral}
              handleChangeFormSearch={handleSearchDuplicateInPersonalGeneral}
            />
          )}

          {openCheckInDependentPersonPopup && (
            <ListCheckInDependentPerson
              open={openCheckInDependentPersonPopup}
              onClose={handleCloseCheckInDependentPersonPopup}
              initCheckInDependentPerson={initCheckInDependentPerson}
              saveCheckCompanions={saveCheckCompanions}
              handleChangeFormSearchDependentPerson={
                handleChangeFormSearchDependentPerson
              }
              customerSourceForCompanionDefault={
                customerSourceForCompanionDefault
              }
              handleChangeFormSearchDuplicateOnlyLead={
                handleChangeFormSearchDuplicateOnlyLead
              }
            />
          )}

          {openPopupSearchDependentPersonLead && (
            <LeadSearchPopup
              open={openPopupSearchDependentPersonLead}
              handleClose={handleClosePopupSearchDependentPersonLead}
              leadPatient={duplicatePatients}
              searchLead={searchDuplicatePatient}
              handleSelect={handleSelectDependentPersonLeadPatient}
              handleChangeFormSearch={handleChangeFormSearchDependentPerson}
            />
          )}

          {openPopupCheckDuplicateDependentPerson && (
            <PopupDuplicate
              open={openPopupCheckDuplicateDependentPerson}
              handleClose={handleClosePopupCheckDuplicateDependentPerson}
              duplicatePatients={duplicatePatients}
              searchCheckIn={searchDuplicatePatient}
              onSelectPatient={handleSelectDuplicateDependentPerson}
              handleChangeFormSearch={handleChangeFormSearchDependentPerson}
            />
          )}

          {openCheckInHistoryElasticPopup && (
            <CheckInHistoryElasticPopup
              open={openCheckInHistoryElasticPopup}
              handleClose={handleCloseCheckInHistoryElastic}
              searchData={searchCheckInHistoryElastic}
              pageData={pageCheckInHistoryElastic}
              handleChangeFormSearch={handleChangeFormSearchCheckInHistoryElastic}
            />
          )}

          <DialogError />
        </Grid>
      </Grid>
    </>
  );
};

const DialogError = observer(() => {
  const { openConfirmDeleteError, setOpenConfirmDeleteError } =
    useStore().patientManagementStore.listCheckInStore;
  return (
    <>
      {!!openConfirmDeleteError && (
        <GlobitsConfirmationDialog
          maxWidth={"xs"}
          title="Thông báo!"
          text={openConfirmDeleteError?.responseDetail}
          onConfirmDialogClose={() => {
            setOpenConfirmDeleteError(null);
          }}
          cancel="Đóng"
          open={!!openConfirmDeleteError}
        />
      )}
    </>
  );
});

export default memo(observer(ListCheckIn));
